export class UserRoleRequest {
  public username: string;
  public userID: string;
  public isInternalUser: boolean;
  public providerCollectionID: string;
}
